import { StyleSheet, View } from 'react-native'
import { Card, Icon, Text } from 'react-native-paper'
import { useSemanticColors } from '@/constants/SemanticColors'
import type { IconType } from '@/lib/types'
import { Button } from '@/ui/Button'

interface EmptyCardProps {
    icon: IconType
    title: string
    subtitle: string
    buttonLabel?: string
    onButtonPress?: () => void
}

export function EmptyCard({ icon, title, subtitle, buttonLabel, onButtonPress }: EmptyCardProps) {
    const semanticColors = useSemanticColors()

    return (
        <Card style={[styles.card, { borderColor: semanticColors.divider }]}>
            <Card.Content style={styles.content}>
                <Icon source={icon} size={48} color={semanticColors.mutedText} />
                <View style={styles.textContainer}>
                    <Text variant="headlineSmall" style={styles.title}>
                        {title}
                    </Text>
                    <Text variant="bodyMedium" style={{ color: semanticColors.mutedText }}>
                        {subtitle}
                    </Text>
                </View>
                {buttonLabel && onButtonPress ? (
                    <Button
                        title={buttonLabel}
                        mode="contained"
                        icon="plus"
                        onPress={onButtonPress}
                    />
                ) : null}
            </Card.Content>
        </Card>
    )
}

const styles = StyleSheet.create({
    card: {
        margin: 16,
        borderStyle: 'dashed',
        borderWidth: 1,
    },
    content: {
        alignItems: 'center',
        gap: 16,
        padding: 24,
    },
    textContainer: {
        alignItems: 'center',
        gap: 8,
    },
    title: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
})
